import PropTypes from 'prop-types';
import React, {useState, useEffect, useRef} from 'react';
import Image from 'next/image'; 
import { BlogItemStyled } from './BlogItemStyled';
import { PRODUCT_CARD_DEFAULT } from '../../Assets/images';
import { dataLayerSendEvent } from 'Epharmacy/EpharmacyAnalytics';
import withAnalytics from '../Hoc/WithAnalytics';
import { PAGE_NAME } from  '@common/Constants/analytics';
import { getImageUrlWithSize  } from '@common/Utility/common-utils';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';

const BlogItem = (props) => {
    const {
        title,
        subTitle,
        imageWeb, 
        order, 
        linkWeb, 
        blogCategory, 
        blogDurationTime,
        authorName, 
        authorImageWeb, 
        index,
        screen_name,
        page_type,
        myaster_category,
        doctor_id,
        doctor_name,
        speciality,
    } = props;

    const [charLimit, setCharLimit] = useState();
    const [blogCharLimit, setBlogCharLimit] = useState(); 
    const [eventFired, setEventFired] = useState(false); 
    const inViewRef = useRef();
    const generateURL = useNavigationURL();

    const onBannerClick = () => {
        dataLayerSendEvent('blog_post_click', {
            screen_name: screen_name,
            page_type: page_type,
            myaster_category: myaster_category,
            section_name: title,
            blog_name: subTitle,
            blog_category: blogCategory,
            position: order,
            ...((page_type === PAGE_NAME?.DDP) && {doctor_id}),
            ...((page_type === PAGE_NAME?.DDP) && {doctor_name}),
            ...((page_type === PAGE_NAME?.DDP) && {speciality}),
        });
    }

    useEffect(() => {
        let charCount;
        let blogCharCount;

        if (window) {
          if (window.innerWidth < 980 && window.innerWidth > 767) {
            charCount = 41;
            blogCharCount = 10;
          } else if (window.innerWidth < 980) {
            charCount = 53;
            blogCharCount = 13;
          } else {
            charCount = 56;
            blogCharCount = 16;
          }
          setCharLimit(charCount);
          setBlogCharLimit(blogCharCount);
        }
    }, []);

    const handleInView = () => {
        if (!eventFired) {
            dataLayerSendEvent('blog_post_impressions', {
                screen_name: screen_name,
                page_type: page_type,
                myaster_category: myaster_category,
                section_name: title,
                blog_name: subTitle,
                blog_category: blogCategory,
                position: order,
                ...((page_type === PAGE_NAME?.DDP) && {doctor_id}),
                ...((page_type === PAGE_NAME?.DDP) && {doctor_name}),
                ...((page_type === PAGE_NAME?.DDP) && {speciality}),
               
            });
            setEventFired(true);
        }
    };

    const constructor = handleInView;

    const BlogItemWithAnalytics = withAnalytics(() => (
        <BlogItemStyled ref={inViewRef}>
            
            <div className="dealItemBox" data-blogid={index}>
                <div className="item">                     
                    <a href={generateURL(linkWeb)} target='_blank' onClick={onBannerClick}>
                        
                        <div data-test="div_2" >
                            <Image className='abcd' src={getImageUrlWithSize(imageWeb, 198, 162) || PRODUCT_CARD_DEFAULT.src} alt={subTitle} width="198" height="162" />
                        </div>
                        
                        <div>
                            <div className="name" title={subTitle}>
                                {subTitle?.length >= charLimit ? `${subTitle.substr(0, charLimit).trim()}...` : subTitle}
                            </div>

                            {blogCategory !== '' && blogCategory !== '-' && blogCategory && (
                                <div className={`delivery`}>
                                    {blogCategory?.length >= blogCharLimit ? `${blogCategory.substr(0, blogCharLimit).trim()}...` : blogCategory} <span>• {blogDurationTime}</span><span> {(blogDurationTime === 1 || blogDurationTime === 0) ? 'min read' : 'mins read'} </span>
                                </div>
                            )}
                            
                            <div className='deliverySecond'>
                                {authorImageWeb !== '' && authorImageWeb !== '-' && <Image src={getImageUrlWithSize(authorImageWeb, 32, 32) || PRODUCT_CARD_DEFAULT.src} alt={subTitle} width="32" height="32"/>}
                                {authorName && <span className = 'blogsText'>By {authorName}</span>}
                            </div>
                            
                        </div>
                    </a>
                
                </div>
            </div>
            
        </BlogItemStyled>
    ), constructor, inViewRef)

    return (
        <BlogItemWithAnalytics />
    );
};

BlogItem.propTypes = {
    title: PropTypes.string,
    blogPages: PropTypes.string,
    subTitle: PropTypes.string,
    imageWeb: PropTypes.string, 
    order: PropTypes.number,
    linkWeb: PropTypes.string, 
    blogCategory: PropTypes.string,
    blogDurationTime: PropTypes.number,
    authorName: PropTypes.string, 
    authorImageWeb: PropTypes.string, 
    index: PropTypes.number,
    screen_name: PropTypes.string,
    page_type: PropTypes.string,
    myaster_category: PropTypes.string,
    doctor_id: PropTypes.string,
    doctor_name: PropTypes.string,
    speciality: PropTypes.string,
};

BlogItem.defaultProps = {
    title: '',
    blogPages: '',
    subTitle: '',
    imageWeb: '',
    order: 0,
    linkWeb: '',
    blogCategory: '',
    blogDurationTime: 0,
    authorName: '',
    authorImageWeb: '',
    index: 0,
    screen_name: '',
    page_type: '',
    myaster_category: '',
    doctor_id:'',
    doctor_name: '',
    speciality: '',
};
  
export default BlogItem;